/* tslint:disable */
/* This is generated by ts_routes-rails */

export type ScalarType = string | number | boolean;

function $buildOptions(options: any, names: string[]): string {
  if (options) {
    let anchor = "";
    const q = [] as string[];
    for (const key of Object.keys(options)) {
      if (names.indexOf(key) !== -1) {
        // the key is already consumed
        continue;
      }

      const value = options[key];

      if (key === "anchor") {
        anchor = `#${$encode(value)}`;
      } else {
        $buildQuery(q, key, value);
      }
    }
    return (q.length > 0 ? "?" + q.join("&") : "") + anchor;
  } else {
    return "";
  }
}

function $buildQuery(q: string[], key: string, value: any) {
  if ($isScalarType(value)) {
    q.push(`${$encode(key)}=${$encode(value)}`);
  } else if (Array.isArray(value)) {
    for (const v of value) {
      $buildQuery(q, `${key}[]`, v);
    }
  } else if (value != null) {
    // i.e. non-null, non-scalar, non-array type
    for (const k of Object.keys(value)) {
      $buildQuery(q, `${key}[${k}]`, value[k]);
    }
  }
}

function $encode(value: any): string {
  return encodeURIComponent(value);
}

function $isScalarType(value: any): value is ScalarType {
  return (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  );
}

function $isPresent(value: any): boolean {
  return value != null && ("" + value).length > 0;
}

function $hasPresentOwnProperty(options: any, key: string): boolean {
  return options && options.hasOwnProperty(key) && $isPresent(options[key]);
}

/** /ems_connect */
export function emsConnectPath(options?: object): string {
  return "/" + "ems_connect" + $buildOptions(options, []);
}

/** /ems_connect/nexl/uninstalls/new(.:format) */
export function emsConnectNexlUninstallsNewPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "nexl" + "/" + "uninstalls" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/nexl/installations/:installation_id/uninstall/new(.:format) */
export function emsConnectNewNexlInstallationUninstallPath(installation_id: ScalarType, options?: object): string {
  return "/" + "ems_connect" + "/" + "nexl" + "/" + "installations" + "/" + installation_id + "/" + "uninstall" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["installation_id","format"]);
}

/** /ems_connect/nexl/installations/:installation_id/uninstall(.:format) */
export function emsConnectNexlInstallationUninstallPath(installation_id: ScalarType, options?: object): string {
  return "/" + "ems_connect" + "/" + "nexl" + "/" + "installations" + "/" + installation_id + "/" + "uninstall" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["installation_id","format"]);
}

/** /ems_connect/nexl/installations(.:format) */
export function emsConnectNexlInstallationsPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "nexl" + "/" + "installations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/nexl/sync_list_hooks/:sync_list_hook_id/requests(.:format) */
export function emsConnectNexlSyncListHookRequestsPath(sync_list_hook_id: ScalarType, options?: object): string {
  return "/" + "ems_connect" + "/" + "nexl" + "/" + "sync_list_hooks" + "/" + sync_list_hook_id + "/" + "requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["sync_list_hook_id","format"]);
}

/** /ems_connect/concep/connectors(.:format) */
export function emsConnectConcepConnectorsPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "concep" + "/" + "connectors" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/concep/connectors/new(.:format) */
export function emsConnectNewConcepConnectorPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "concep" + "/" + "connectors" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/concep/connectors/:id/edit(.:format) */
export function emsConnectEditConcepConnectorPath(id: ScalarType, options?: object): string {
  return "/" + "ems_connect" + "/" + "concep" + "/" + "connectors" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /ems_connect/concep/connectors/:id(.:format) */
export function emsConnectConcepConnectorPath(id: ScalarType, options?: object): string {
  return "/" + "ems_connect" + "/" + "concep" + "/" + "connectors" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /ems_connect/brevo/connectors(.:format) */
export function emsConnectBrevoConnectorsPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "brevo" + "/" + "connectors" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/brevo/connectors/new(.:format) */
export function emsConnectNewBrevoConnectorPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "brevo" + "/" + "connectors" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/brevo/connectors/:id/edit(.:format) */
export function emsConnectEditBrevoConnectorPath(id: ScalarType, options?: object): string {
  return "/" + "ems_connect" + "/" + "brevo" + "/" + "connectors" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /ems_connect/brevo/connectors/:id(.:format) */
export function emsConnectBrevoConnectorPath(id: ScalarType, options?: object): string {
  return "/" + "ems_connect" + "/" + "brevo" + "/" + "connectors" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /ems_connect/tester/connectors(.:format) */
export function emsConnectTesterConnectorsPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "tester" + "/" + "connectors" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/tester/connectors/new(.:format) */
export function emsConnectNewTesterConnectorPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "tester" + "/" + "connectors" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/tester/last_synced_list(.:format) */
export function emsConnectTesterLastSyncedListPath(options?: object): string {
  return "/" + "ems_connect" + "/" + "tester" + "/" + "last_synced_list" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ems_connect/tester/synced_lists/:id(.:format) */
export function emsConnectTesterSyncedListPath(id: ScalarType, options?: object): string {
  return "/" + "ems_connect" + "/" + "tester" + "/" + "synced_lists" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /power_automate/swagger(.:format) */
export function powerAutomateSwaggerPath(options?: object): string {
  return "/" + "power_automate" + "/" + "swagger" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/custom_objects_templates/batch_action(.:format) */
export function batchActionAdminCustomObjectsTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "custom_objects_templates" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/custom_objects_templates(.:format) */
export function adminCustomObjectsTemplatesPath(options?: object): string {
  return "/" + "admin" + "/" + "custom_objects_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/data_cleaner_duplicate_companies/batch_action(.:format) */
export function batchActionAdminDataCleanerDuplicateCompaniesPath(options?: object): string {
  return "/" + "admin" + "/" + "data_cleaner_duplicate_companies" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/data_cleaner_duplicate_companies(.:format) */
export function adminDataCleanerDuplicateCompaniesPath(options?: object): string {
  return "/" + "admin" + "/" + "data_cleaner_duplicate_companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/data_cleaner_duplicate_contacts/batch_action(.:format) */
export function batchActionAdminDataCleanerDuplicateContactsPath(options?: object): string {
  return "/" + "admin" + "/" + "data_cleaner_duplicate_contacts" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/data_cleaner_duplicate_contacts(.:format) */
export function adminDataCleanerDuplicateContactsPath(options?: object): string {
  return "/" + "admin" + "/" + "data_cleaner_duplicate_contacts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_campaigns/:id/impersonate_service_account(.:format) */
export function impersonateServiceAccountAdminEmailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaigns" + "/" + id + "/" + "impersonate_service_account" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_campaigns/:id/resend(.:format) */
export function resendAdminEmailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaigns" + "/" + id + "/" + "resend" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_campaigns/:id/calculate_analytics(.:format) */
export function calculateAnalyticsAdminEmailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaigns" + "/" + id + "/" + "calculate_analytics" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_campaigns/batch_action(.:format) */
export function batchActionAdminEmailMarketingCampaignsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaigns" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_campaigns(.:format) */
export function adminEmailMarketingCampaignsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaigns" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_campaigns/:id(.:format) */
export function adminEmailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaigns" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_configurations/:id/bulk_recalculate_campaign_analytics(.:format) */
export function bulkRecalculateCampaignAnalyticsAdminEmailMarketingConfigurationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_configurations" + "/" + id + "/" + "bulk_recalculate_campaign_analytics" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_configurations/:id/create_mailgun_webhook(.:format) */
export function createMailgunWebhookAdminEmailMarketingConfigurationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_configurations" + "/" + id + "/" + "create_mailgun_webhook" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_configurations/batch_action(.:format) */
export function batchActionAdminEmailMarketingConfigurationsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_configurations" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_configurations(.:format) */
export function adminEmailMarketingConfigurationsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_configurations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_configurations/new(.:format) */
export function newAdminEmailMarketingConfigurationPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_configurations" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_configurations/:id/edit(.:format) */
export function editAdminEmailMarketingConfigurationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_configurations" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_configurations/:id(.:format) */
export function adminEmailMarketingConfigurationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_configurations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_mailgun_events/batch_action(.:format) */
export function batchActionAdminEmailMarketingMailgunEventsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_mailgun_events" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_mailgun_events(.:format) */
export function adminEmailMarketingMailgunEventsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_mailgun_events" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_mailgun_events/:id(.:format) */
export function adminEmailMarketingMailgunEventPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_mailgun_events" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_schedule_campaign_recipients/batch_action(.:format) */
export function batchActionAdminEmailMarketingScheduleCampaignRecipientsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_schedule_campaign_recipients" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_schedule_campaign_recipients(.:format) */
export function adminEmailMarketingScheduleCampaignRecipientsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_schedule_campaign_recipients" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_schedule_campaign_recipients/:id(.:format) */
export function adminEmailMarketingScheduleCampaignRecipientPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_schedule_campaign_recipients" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_schedule_campaigns/batch_action(.:format) */
export function batchActionAdminEmailMarketingScheduleCampaignsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_schedule_campaigns" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_schedule_campaigns(.:format) */
export function adminEmailMarketingScheduleCampaignsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_schedule_campaigns" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_schedule_campaigns/:id(.:format) */
export function adminEmailMarketingScheduleCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_schedule_campaigns" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_send_batch_message_requests/batch_action(.:format) */
export function batchActionAdminEmailMarketingSendBatchMessageRequestsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_send_batch_message_requests" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_send_batch_message_requests(.:format) */
export function adminEmailMarketingSendBatchMessageRequestsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_send_batch_message_requests" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_send_batch_message_requests/:id(.:format) */
export function adminEmailMarketingSendBatchMessageRequestPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_send_batch_message_requests" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/email_marketing_campaign_mutations/batch_action(.:format) */
export function batchActionAdminEmailMarketingCampaignMutationsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaign_mutations" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_campaign_mutations(.:format) */
export function adminEmailMarketingCampaignMutationsPath(options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaign_mutations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/email_marketing_campaign_mutations/:id(.:format) */
export function adminEmailMarketingCampaignMutationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "email_marketing_campaign_mutations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/embedded_reporting_configurations/batch_action(.:format) */
export function batchActionAdminEmbeddedReportingConfigurationsPath(options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_configurations" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/embedded_reporting_configurations(.:format) */
export function adminEmbeddedReportingConfigurationsPath(options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_configurations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/embedded_reporting_configurations/new(.:format) */
export function newAdminEmbeddedReportingConfigurationPath(options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_configurations" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/embedded_reporting_configurations/:id/edit(.:format) */
export function editAdminEmbeddedReportingConfigurationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_configurations" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/embedded_reporting_configurations/:id(.:format) */
export function adminEmbeddedReportingConfigurationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_configurations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/embedded_reporting_embedded_dashboards/batch_action(.:format) */
export function batchActionAdminEmbeddedReportingEmbeddedDashboardsPath(options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_embedded_dashboards" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/embedded_reporting_embedded_dashboards(.:format) */
export function adminEmbeddedReportingEmbeddedDashboardsPath(options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_embedded_dashboards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/embedded_reporting_embedded_dashboards/new(.:format) */
export function newAdminEmbeddedReportingEmbeddedDashboardPath(options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_embedded_dashboards" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/embedded_reporting_embedded_dashboards/:id/edit(.:format) */
export function editAdminEmbeddedReportingEmbeddedDashboardPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_embedded_dashboards" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/embedded_reporting_embedded_dashboards/:id(.:format) */
export function adminEmbeddedReportingEmbeddedDashboardPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "embedded_reporting_embedded_dashboards" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/enrichment_domain_logos/:id/apply_logo(.:format) */
export function applyLogoAdminEnrichmentDomainLogoPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "enrichment_domain_logos" + "/" + id + "/" + "apply_logo" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/form_builder_form_elements/batch_action(.:format) */
export function batchActionAdminFormBuilderFormElementsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_form_elements" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_form_elements(.:format) */
export function adminFormBuilderFormElementsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_form_elements" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_form_elements/:id(.:format) */
export function adminFormBuilderFormElementPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "form_builder_form_elements" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/form_builder_form_versions/batch_action(.:format) */
export function batchActionAdminFormBuilderFormVersionsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_form_versions" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_form_versions(.:format) */
export function adminFormBuilderFormVersionsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_form_versions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_form_versions/:id(.:format) */
export function adminFormBuilderFormVersionPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "form_builder_form_versions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/form_builder_forms/batch_action(.:format) */
export function batchActionAdminFormBuilderFormsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_forms" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_forms(.:format) */
export function adminFormBuilderFormsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_forms" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_forms/:id(.:format) */
export function adminFormBuilderFormPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "form_builder_forms" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/form_builder_input_elements/batch_action(.:format) */
export function batchActionAdminFormBuilderInputElementsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_input_elements" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_input_elements(.:format) */
export function adminFormBuilderInputElementsPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_input_elements" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_input_elements/:id(.:format) */
export function adminFormBuilderInputElementPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "form_builder_input_elements" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/form_builder_workflow_subscribers/batch_action(.:format) */
export function batchActionAdminFormBuilderWorkflowSubscribersPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_workflow_subscribers" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/form_builder_workflow_subscribers(.:format) */
export function adminFormBuilderWorkflowSubscribersPath(options?: object): string {
  return "/" + "admin" + "/" + "form_builder_workflow_subscribers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/list_cleaner_executions/batch_action(.:format) */
export function batchActionAdminListCleanerExecutionsPath(options?: object): string {
  return "/" + "admin" + "/" + "list_cleaner_executions" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/list_cleaner_executions(.:format) */
export function adminListCleanerExecutionsPath(options?: object): string {
  return "/" + "admin" + "/" + "list_cleaner_executions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/list_cleaner_executions/:id(.:format) */
export function adminListCleanerExecutionPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "list_cleaner_executions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/list_cleaner_verification_caches/delete_all(.:format) */
export function deleteAllAdminListCleanerVerificationCachesPath(options?: object): string {
  return "/" + "admin" + "/" + "list_cleaner_verification_caches" + "/" + "delete_all" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/list_cleaner_verification_caches/batch_action(.:format) */
export function batchActionAdminListCleanerVerificationCachesPath(options?: object): string {
  return "/" + "admin" + "/" + "list_cleaner_verification_caches" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/list_cleaner_verification_caches(.:format) */
export function adminListCleanerVerificationCachesPath(options?: object): string {
  return "/" + "admin" + "/" + "list_cleaner_verification_caches" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/marketing_lists_campaign_managers/batch_action(.:format) */
export function batchActionAdminMarketingListsCampaignManagersPath(options?: object): string {
  return "/" + "admin" + "/" + "marketing_lists_campaign_managers" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/marketing_lists_campaign_managers(.:format) */
export function adminMarketingListsCampaignManagersPath(options?: object): string {
  return "/" + "admin" + "/" + "marketing_lists_campaign_managers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/marketing_lists_campaign_managers/:id(.:format) */
export function adminMarketingListsCampaignManagerPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "marketing_lists_campaign_managers" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/engagement_reports_engagement_reports/batch_action(.:format) */
export function batchActionAdminEngagementReportsEngagementReportsPath(options?: object): string {
  return "/" + "admin" + "/" + "engagement_reports_engagement_reports" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/engagement_reports_engagement_reports(.:format) */
export function adminEngagementReportsEngagementReportsPath(options?: object): string {
  return "/" + "admin" + "/" + "engagement_reports_engagement_reports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/engagement_reports_engagement_reports/new(.:format) */
export function newAdminEngagementReportsEngagementReportPath(options?: object): string {
  return "/" + "admin" + "/" + "engagement_reports_engagement_reports" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/engagement_reports_engagement_reports/:id(.:format) */
export function adminEngagementReportsEngagementReportPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "engagement_reports_engagement_reports" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/opportunity_tracking_opportunities/batch_action(.:format) */
export function batchActionAdminOpportunityTrackingOpportunitiesPath(options?: object): string {
  return "/" + "admin" + "/" + "opportunity_tracking_opportunities" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/opportunity_tracking_opportunities(.:format) */
export function adminOpportunityTrackingOpportunitiesPath(options?: object): string {
  return "/" + "admin" + "/" + "opportunity_tracking_opportunities" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/research_reports_role_permissions/batch_action(.:format) */
export function batchActionAdminResearchReportsRolePermissionsPath(options?: object): string {
  return "/" + "admin" + "/" + "research_reports_role_permissions" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/research_reports_role_permissions(.:format) */
export function adminResearchReportsRolePermissionsPath(options?: object): string {
  return "/" + "admin" + "/" + "research_reports_role_permissions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/research_reports_role_permissions/:id/edit(.:format) */
export function editAdminResearchReportsRolePermissionPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "research_reports_role_permissions" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/research_reports_role_permissions/:id(.:format) */
export function adminResearchReportsRolePermissionPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "research_reports_role_permissions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/company_reports_configurations/batch_action(.:format) */
export function batchActionAdminCompanyReportsConfigurationsPath(options?: object): string {
  return "/" + "admin" + "/" + "company_reports_configurations" + "/" + "batch_action" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company_reports_configurations(.:format) */
export function adminCompanyReportsConfigurationsPath(options?: object): string {
  return "/" + "admin" + "/" + "company_reports_configurations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company_reports_configurations/new(.:format) */
export function newAdminCompanyReportsConfigurationPath(options?: object): string {
  return "/" + "admin" + "/" + "company_reports_configurations" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /admin/company_reports_configurations/:id/edit(.:format) */
export function editAdminCompanyReportsConfigurationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "company_reports_configurations" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /admin/company_reports_configurations/:id(.:format) */
export function adminCompanyReportsConfigurationPath(id: ScalarType, options?: object): string {
  return "/" + "admin" + "/" + "company_reports_configurations" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /sessions/user_chosen(.:format) */
export function userChosenPath(options?: object): string {
  return "/" + "sessions" + "/" + "user_chosen" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /odata/api/v1/swagger(.:format) */
export function swaggerOdataPath(options?: object): string {
  return "/" + "odata" + "/" + "api" + "/" + "v1" + "/" + "swagger" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /email_marketing/fake_gun(.:format) */
export function emailMarketingFakeGunRootPath(options?: object): string {
  return "/" + "email_marketing" + "/" + "fake_gun" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /email_marketing/fake_gun/v3/:mailgun_domain/messages(.:format) */
export function emailMarketingFakeGunMessagesPath(mailgun_domain: ScalarType, options?: object): string {
  return "/" + "email_marketing" + "/" + "fake_gun" + "/" + "v3" + "/" + mailgun_domain + "/" + "messages" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["mailgun_domain","format"]);
}

/** /serverside/email_marketing/campaigns/search(.:format) */
export function searchEmailMarketingCampaignsPath(options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + "/" + "search" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /serverside/email_marketing/campaigns/:id/archive(.:format) */
export function archiveEmailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + "/" + id + "/" + "archive" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/email_marketing/campaigns/:id/schedule(.:format) */
export function scheduleEmailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + "/" + id + "/" + "schedule" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/email_marketing/campaigns/:id/test(.:format) */
export function testEmailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + "/" + id + "/" + "test" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/email_marketing/campaigns/:campaign_id/recipients(.:format) */
export function emailMarketingCampaignRecipientsPath(campaign_id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + "/" + campaign_id + "/" + "recipients" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["campaign_id","format"]);
}

/** /serverside/email_marketing/campaigns/:campaign_id/recipients/:id(.:format) */
export function emailMarketingCampaignRecipientPath(campaign_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + "/" + campaign_id + "/" + "recipients" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["campaign_id","id","format"]);
}

/** /serverside/email_marketing/campaigns(.:format) */
export function emailMarketingCampaignsPath(options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /serverside/email_marketing/campaigns/:id/edit(.:format) */
export function editEmailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/email_marketing/campaigns/:id(.:format) */
export function emailMarketingCampaignPath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "campaigns" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/email_marketing/templates/:id/duplicate(.:format) */
export function duplicateEmailMarketingTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "templates" + "/" + id + "/" + "duplicate" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/email_marketing/templates(.:format) */
export function emailMarketingTemplatesPath(options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /serverside/email_marketing/templates/:id/edit(.:format) */
export function editEmailMarketingTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "templates" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/email_marketing/templates/:id(.:format) */
export function emailMarketingTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "email_marketing" + "/" + "templates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/internal_industries(.:format) */
export function serversideInternalIndustriesPath(options?: object): string {
  return "/" + "serverside" + "/" + "internal_industries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /serverside/internal_industries/new(.:format) */
export function newServersideInternalIndustryPath(options?: object): string {
  return "/" + "serverside" + "/" + "internal_industries" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /serverside/internal_industries/:id/edit(.:format) */
export function editServersideInternalIndustryPath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "internal_industries" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/internal_industries/:id(.:format) */
export function serversideInternalIndustryPath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "internal_industries" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/interactions/key_activity_titles(.:format) */
export function interactionsKeyActivityTitlesPath(options?: object): string {
  return "/" + "serverside" + "/" + "interactions" + "/" + "key_activity_titles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /serverside/interactions/key_activity_titles/:id(.:format) */
export function interactionsKeyActivityTitlePath(id: ScalarType, options?: object): string {
  return "/" + "serverside" + "/" + "interactions" + "/" + "key_activity_titles" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /serverside/marketing_lists/direct_to_ems_apps(.:format) */
export function marketingListsDirectToEmsAppsPath(options?: object): string {
  return "/" + "serverside" + "/" + "marketing_lists" + "/" + "direct_to_ems_apps" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /embedded_reporting/metabase/sso(.:format) */
export function embeddedReportingMetabaseSsoPath(options?: object): string {
  return "/" + "embedded_reporting" + "/" + "metabase" + "/" + "sso" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /embedded_reporting/metabase/dashboard(.:format) */
export function embeddedReportingMetabaseDashboardPath(options?: object): string {
  return "/" + "embedded_reporting" + "/" + "metabase" + "/" + "dashboard" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /project_management/template/:id(.:format) */
export function projectManagementPath(id: ScalarType, options?: object): string {
  return "/" + "project_management" + "/" + "template" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /project_management/:id/upload(.:format) */
export function projectManagementProjectsUploadFilePath(id: ScalarType, options?: object): string {
  return "/" + "project_management" + "/" + id + "/" + "upload" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /form_builder/forms/:id/edit_styles(.:format) */
export function editStylesFormBuilderFormPath(id: ScalarType, options?: object): string {
  return "/" + "form_builder" + "/" + "forms" + "/" + id + "/" + "edit_styles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /form_builder/forms/:id(.:format) */
export function formBuilderFormPath(id: ScalarType, options?: object): string {
  return "/" + "form_builder" + "/" + "forms" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /form_builder/admin/:id/restore(.:format) */
export function restoreFormBuilderAdminPath(id: ScalarType, options?: object): string {
  return "/" + "form_builder" + "/" + "admin" + "/" + id + "/" + "restore" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /form_builder/admin(.:format) */
export function formBuilderAdminIndexPath(options?: object): string {
  return "/" + "form_builder" + "/" + "admin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /form_builder/admin/:id(.:format) */
export function formBuilderAdminPath(id: ScalarType, options?: object): string {
  return "/" + "form_builder" + "/" + "admin" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /form_builder/general_settings/edit(.:format) */
export function editFormBuilderGeneralSettingsPath(options?: object): string {
  return "/" + "form_builder" + "/" + "general_settings" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /form_builder/general_settings(.:format) */
export function formBuilderGeneralSettingsPath(options?: object): string {
  return "/" + "form_builder" + "/" + "general_settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /email_marketing/access/campaigns/:id(.:format) */
export function campaignEmailTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "email_marketing" + "/" + "access" + "/" + "campaigns" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /email_marketing/unsubscribe/:token(.:format) */
export function emailMarketingUnsubscribePath(token: ScalarType, options?: object): string {
  return "/" + "email_marketing" + "/" + "unsubscribe" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["token","format"]);
}

/** /mobile/contact_request/:listUid/tab/:tabUid(.:format) */
export function mobileContactRequestTabPath(listUid: ScalarType, tabUid: ScalarType, options?: object): string {
  return "/" + "mobile" + "/" + "contact_request" + "/" + listUid + "/" + "tab" + "/" + tabUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listUid","tabUid","format"]);
}

/** /mobile/callback/auth(.:format) */
export function mobileCallbackAuthPath(options?: object): string {
  return "/" + "mobile" + "/" + "callback" + "/" + "auth" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /mobile/*path(.:format) */
export function mobilePath(path: ScalarType[], options?: object): string {
  return "/" + "mobile" + "/" + path.map((part) => $encode(part)).join("/") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["path","format"]);
}

/** /contacts(/:tabUid)(.:format) */
export function contactsTabPath(options?: object): string {
  return "/" + "contacts" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /contacts/default_tab/:defaultTabUid(.:format) */
export function contactsDefaultTabPath(defaultTabUid: ScalarType, options?: object): string {
  return "/" + "contacts" + "/" + "default_tab" + "/" + defaultTabUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["defaultTabUid","format"]);
}

/** /:assigned/:status/tasks(.:format) */
export function myStatusTasksPath(assigned: ScalarType, status: ScalarType, options?: object): string {
  return "/" + assigned + "/" + status + "/" + "tasks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["assigned","status","format"]);
}

/** /my/contacts(/:tabUid)(.:format) */
export function myContactsTabPath(options?: object): string {
  return "/" + "my" + "/" + "contacts" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /my/contacts/default_tab/:defaultTabUid(.:format) */
export function myContactsDefaultTabPath(defaultTabUid: ScalarType, options?: object): string {
  return "/" + "my" + "/" + "contacts" + "/" + "default_tab" + "/" + defaultTabUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["defaultTabUid","format"]);
}

/** /my/companies(/:tabUid)(.:format) */
export function myCompaniesTabPath(options?: object): string {
  return "/" + "my" + "/" + "companies" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /my/upcoming_meetings(.:format) */
export function myUpcomingMeetingsPath(options?: object): string {
  return "/" + "my" + "/" + "upcoming_meetings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /my/recent_meetings(.:format) */
export function myRecentMeetingsPath(options?: object): string {
  return "/" + "my" + "/" + "recent_meetings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /my/calendar_view(/:meetingUid)(.:format) */
export function myCalendarViewPath(options?: object): string {
  return "/" + "my" + "/" + "calendar_view" + ($hasPresentOwnProperty(options, "meetingUid") ? "/" + (options as any).meetingUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["meetingUid","format"]);
}

/** /opportunity_tracking(/:tabUid)(.:format) */
export function opportunitiesTabPath(options?: object): string {
  return "/" + "opportunity_tracking" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /my/opportunity_tracking(/:tabUid)(.:format) */
export function myOpportunitiesTabPath(options?: object): string {
  return "/" + "my" + "/" + "opportunity_tracking" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /my/stay_in_touch(.:format) */
export function myStayInTouchPath(options?: object): string {
  return "/" + "my" + "/" + "stay_in_touch" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /my/projects(.:format) */
export function myProjectsPath(options?: object): string {
  return "/" + "my" + "/" + "projects" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /project/:project(.:format) */
export function projectPath(project: ScalarType, options?: object): string {
  return "/" + "project" + "/" + project + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["project","format"]);
}

/** /project/:project/tab/:tabUid(.:format) */
export function projectTabPath(project: ScalarType, tabUid: ScalarType, options?: object): string {
  return "/" + "project" + "/" + project + "/" + "tab" + "/" + tabUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["project","tabUid","format"]);
}

/** /project/:project/default_tab/:defaultTabUid(.:format) */
export function projectDefaultTabPath(project: ScalarType, defaultTabUid: ScalarType, options?: object): string {
  return "/" + "project" + "/" + project + "/" + "default_tab" + "/" + defaultTabUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["project","defaultTabUid","format"]);
}

/** /project/:project/tab/:tabUid/page/:pageId(.:format) */
export function projectPagePath(project: ScalarType, tabUid: ScalarType, pageId: ScalarType, options?: object): string {
  return "/" + "project" + "/" + project + "/" + "tab" + "/" + tabUid + "/" + "page" + "/" + pageId + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["project","tabUid","pageId","format"]);
}

/** /app/:appId(.:format) */
export function appPath(appId: ScalarType, options?: object): string {
  return "/" + "app" + "/" + appId + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["appId","format"]);
}

/** /app/:appId/tab/:tabUid(.:format) */
export function appTabPath(appId: ScalarType, tabUid: ScalarType, options?: object): string {
  return "/" + "app" + "/" + appId + "/" + "tab" + "/" + tabUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["appId","tabUid","format"]);
}

/** /app/:appId/tab/:tabUid/page/:pageId(.:format) */
export function appTabPagePath(appId: ScalarType, tabUid: ScalarType, pageId: ScalarType, options?: object): string {
  return "/" + "app" + "/" + appId + "/" + "tab" + "/" + tabUid + "/" + "page" + "/" + pageId + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["appId","tabUid","pageId","format"]);
}

/** /project_template/:id(.:format) */
export function projectTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "project_template" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /key_activities(.:format) */
export function keyActivitiesPath(options?: object): string {
  return "/" + "key_activities" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /list/exclusion_list(.:format) */
export function exclusionListPath(options?: object): string {
  return "/" + "list" + "/" + "exclusion_list" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /list/:listId(.:format) */
export function marketingListPath(listId: ScalarType, options?: object): string {
  return "/" + "list" + "/" + listId + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listId","format"]);
}

/** /marketingList/exclusion_list/default_tab/:defaultTabUid(.:format) */
export function marketingExclusionListPath(defaultTabUid: ScalarType, options?: object): string {
  return "/" + "marketingList" + "/" + "exclusion_list" + "/" + "default_tab" + "/" + defaultTabUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["defaultTabUid","format"]);
}

/** /company/:id(.:format) */
export function companyPath(id: ScalarType, options?: object): string {
  return "/" + "company" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /companies(/:tabUid)(.:format) */
export function companiesTabPath(options?: object): string {
  return "/" + "companies" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /reporting(/:tabUid)(.:format) */
export function reportingTabPath(options?: object): string {
  return "/" + "reporting" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /prospects(/:tabUid)(.:format) */
export function prospectsTabPath(options?: object): string {
  return "/" + "prospects" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /my/prospects(/:tabUid)(.:format) */
export function myProspectsTabPath(options?: object): string {
  return "/" + "my" + "/" + "prospects" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /sent_referrals(.:format) */
export function sentReferralsPath(options?: object): string {
  return "/" + "sent_referrals" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /received_referrals(.:format) */
export function receivedReferralsPath(options?: object): string {
  return "/" + "received_referrals" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cleaner/unengaged(.:format) */
export function cleanerUnengagedPath(options?: object): string {
  return "/" + "cleaner" + "/" + "unengaged" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cleaner(.:format) */
export function cleanerPath(options?: object): string {
  return "/" + "cleaner" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cleaner/duplicate_companies(.:format) */
export function cleanerDuplicateCompaniesPath(options?: object): string {
  return "/" + "cleaner" + "/" + "duplicate_companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cleaner/duplicate_contacts(.:format) */
export function cleanerDuplicateContactsPath(options?: object): string {
  return "/" + "cleaner" + "/" + "duplicate_contacts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cleaner/incomplete_contacts(/:tabUid)(.:format) */
export function cleanerIncompleteContactsTabPath(options?: object): string {
  return "/" + "cleaner" + "/" + "incomplete_contacts" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /cleaner/incomplete_contacts/default_tab/:defaultTabUid(.:format) */
export function cleanerIncompleteContactsDefaultTabPath(defaultTabUid: ScalarType, options?: object): string {
  return "/" + "cleaner" + "/" + "incomplete_contacts" + "/" + "default_tab" + "/" + defaultTabUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["defaultTabUid","format"]);
}

/** /cleaner/incomplete_companies(.:format) */
export function cleanerIncompleteCompaniesPath(options?: object): string {
  return "/" + "cleaner" + "/" + "incomplete_companies" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cleaner/hierarchy_placement(.:format) */
export function cleanerHierarchyPlacementPath(options?: object): string {
  return "/" + "cleaner" + "/" + "hierarchy_placement" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /list_cleaner/:listId(.:format) */
export function listCleanerPath(listId: ScalarType, options?: object): string {
  return "/" + "list_cleaner" + "/" + listId + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listId","format"]);
}

/** /templates(.:format) */
export function templatesPath(options?: object): string {
  return "/" + "templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /templates/:templateId/edit_content(.:format) */
export function templatesEditContentPath(templateId: ScalarType, options?: object): string {
  return "/" + "templates" + "/" + templateId + "/" + "edit_content" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["templateId","format"]);
}

/** /marketing_contacts(.:format) */
export function marketingContactsPath(options?: object): string {
  return "/" + "marketing_contacts" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cleaner/archived(.:format) */
export function cleanerArchivedPath(options?: object): string {
  return "/" + "cleaner" + "/" + "archived" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /cleaner/bounced(.:format) */
export function cleanerBouncedPath(options?: object): string {
  return "/" + "cleaner" + "/" + "bounced" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /marketing_lists/ems/setup(.:format) */
export function emsSetupPath(options?: object): string {
  return "/" + "marketing_lists" + "/" + "ems" + "/" + "setup" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /campaigns/:campaignUid(.:format) */
export function campaignPath(campaignUid: ScalarType, options?: object): string {
  return "/" + "campaigns" + "/" + campaignUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["campaignUid","format"]);
}

/** /campaigns/:campaignUid/edit_content(.:format) */
export function campaignEditContentPath(campaignUid: ScalarType, options?: object): string {
  return "/" + "campaigns" + "/" + campaignUid + "/" + "edit_content" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["campaignUid","format"]);
}

/** /industry_mapping(.:format) */
export function industryMappingPath(options?: object): string {
  return "/" + "industry_mapping" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /internal_industries(.:format) */
export function internalIndustriesPath(options?: object): string {
  return "/" + "internal_industries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /advanced_opportunities(/:tabUid)(.:format) */
export function advancedOpportunitiesTabPath(options?: object): string {
  return "/" + "advanced_opportunities" + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["tabUid","format"]);
}

/** /workspaces(.:format) */
export function workspacesPath(options?: object): string {
  return "/" + "workspaces" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /share/:sharedTabUid/view/:currentViewUid(/:token)(/:tabUid)(.:format) */
export function shareViewPath(sharedTabUid: ScalarType, currentViewUid: ScalarType, options?: object): string {
  return "/" + "share" + "/" + sharedTabUid + "/" + "view" + "/" + currentViewUid + ($hasPresentOwnProperty(options, "token") ? "/" + (options as any).token : "") + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["sharedTabUid","currentViewUid","token","tabUid","format"]);
}

/** /share/list/:listId/:token(/:tabUid)(.:format) */
export function shareListPath(listId: ScalarType, token: ScalarType, options?: object): string {
  return "/" + "share" + "/" + "list" + "/" + listId + "/" + token + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listId","token","tabUid","format"]);
}

/** /share(/:sharedTabUid)/view(/:currentViewUid)(/:tabUid)(.:format) */
export function shareViewOldPath(options?: object): string {
  return "/" + "share" + ($hasPresentOwnProperty(options, "sharedTabUid") ? "/" + (options as any).sharedTabUid : "") + "/" + "view" + ($hasPresentOwnProperty(options, "currentViewUid") ? "/" + (options as any).currentViewUid : "") + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["sharedTabUid","currentViewUid","tabUid","format"]);
}

/** /share/list/:listId(/:tabUid)(.:format) */
export function shareListOldPath(listId: ScalarType, options?: object): string {
  return "/" + "share" + "/" + "list" + "/" + listId + ($hasPresentOwnProperty(options, "tabUid") ? "/" + (options as any).tabUid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listId","tabUid","format"]);
}

/** /reports(.:format) */
export function reportsPath(options?: object): string {
  return "/" + "reports" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /report/:reportId(.:format) */
export function embeddedReportPath(reportId: ScalarType, options?: object): string {
  return "/" + "report" + "/" + reportId + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["reportId","format"]);
}

/** /form_builder/forms/:id/edit(.:format) */
export function editFormBuilderFormPath(id: ScalarType, options?: object): string {
  return "/" + "form_builder" + "/" + "forms" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /my/lists(.:format) */
export function myListsPath(options?: object): string {
  return "/" + "my" + "/" + "lists" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /my/lists/contact/:listUid(.:format) */
export function myListsContactListPath(listUid: ScalarType, options?: object): string {
  return "/" + "my" + "/" + "lists" + "/" + "contact" + "/" + listUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listUid","format"]);
}

/** /my/lists/company/:listUid(.:format) */
export function myListsCompanyListPath(listUid: ScalarType, options?: object): string {
  return "/" + "my" + "/" + "lists" + "/" + "company" + "/" + listUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listUid","format"]);
}

/** /my/lists/generic/:listUid(.:format) */
export function myListsGenericListPath(listUid: ScalarType, options?: object): string {
  return "/" + "my" + "/" + "lists" + "/" + "generic" + "/" + listUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listUid","format"]);
}

/** /removed/history/:listId(.:format) */
export function removedHistoryPath(listId: ScalarType, options?: object): string {
  return "/" + "removed" + "/" + "history" + "/" + listId + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["listId","format"]);
}

/** /user_management(.:format) */
export function userManagementPath(options?: object): string {
  return "/" + "user_management" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /user_management/users(.:format) */
export function userManagementUsersPath(options?: object): string {
  return "/" + "user_management" + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /user_management/roles(.:format) */
export function userManagementRolesPath(options?: object): string {
  return "/" + "user_management" + "/" + "roles" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /role_management/:roleUid(.:format) */
export function roleManagementPath(roleUid: ScalarType, options?: object): string {
  return "/" + "role_management" + "/" + roleUid + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["roleUid","format"]);
}

/** /custom_objects/:dataTemplateUid/data_records(.:format) */
export function dtDataRecordsPath(dataTemplateUid: ScalarType, options?: object): string {
  return "/" + "custom_objects" + "/" + dataTemplateUid + "/" + "data_records" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["dataTemplateUid","format"]);
}

/** /research_report/:researchReportUid(/:sectionuid)(.:format) */
export function researchReportPath(researchReportUid: ScalarType, options?: object): string {
  return "/" + "research_report" + "/" + researchReportUid + ($hasPresentOwnProperty(options, "sectionuid") ? "/" + (options as any).sectionuid : "") + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["researchReportUid","sectionuid","format"]);
}
